export const flexGrowCentered = { 
    display: "flex", 
    flexGrow: 1, 
    justifyContent: "center",
};